module.exports = __webpack_public_path__ + "static/media/portable-safes.a79afe35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/hero/portable-safes.jpg
// module id = 1247
// module chunks = 0